import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { Typography, withStyles, CircularProgress } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import ContentHeader from '../components/ContentHeader';
import TripsTable from '../components/TripsTable';

const styles = theme => ({
    root: {
        textAlign: 'left',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    spinner: {
        marginLeft: 'calc(50% - 22px)',
        marginTop: '60px',
        marginBottom: '60px'
    },
    error: {
        margin: '20px 0',
        fontSize: '18px',
        color: red[500],
        textAlign: 'center',
        paddingBottom: '20px'
    },
    passengerInfo: {
        padding: '10px',
        marginBottom: '20px',
        textAlign: 'center'
    }
});

class Trips extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: false,
            trips: []
        };
    }

    async componentDidMount() {
        try {
            const currentSession = await Auth.currentSession();
            const {
                match: {
                    params: { ticketId }
                }
            } = this.props;

            const headers = {
                Authorization: currentSession.getIdToken().getJwtToken()
            };

            let tripsResponse;
            try {
                tripsResponse = await axios.get(
                    `${process.env.REACT_APP_TRIPS_API_ENDPOINT}/trips/by-ticket/${ticketId}`,
                    {
                        headers
                    }
                );
            } catch (e) {
                tripsResponse = [];
                if (e.response.status !== 404) {
                    throw e;
                }
            }

            this.setState({
                loading: false,
                error: false,
                trips: tripsResponse.data || tripsResponse
            });
        } catch (e) {
            this.setState({
                loading: false,
                error: true
            });
        }
    }

    render() {
        const { error, loading, trips } = this.state;
        const { classes } = this.props;

        if (loading) {
            return (
                <CircularProgress
                    id="loading-spinner"
                    className={classes.spinner}
                />
            );
        }

        return (
            <div className={classes.root}>
                <ContentHeader text="Trip details" id="trip-details-heading" />
                {error && (
                    <Typography className={classes.error}>
                        There was a problem retrieving your trip details
                    </Typography>
                )}
                {trips && !error && (
                    <div className={classes.passengerInfo}>
                        <TripsTable trips={trips} />
                    </div>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(Trips);
